"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const uuid_1 = require("uuid");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const GenericObject_1 = require("./GenericObject");
const LodashExtensions_1 = require("../LodashExtensions");
/**
 * An immutable collection of objects. This collection allows to get objects by
 * various of its attributes and also indexes the objects on common attributes.
 */
class GenericImmutableCollection {
    constructor(features, attributes) {
        this._attributes = (0, cloneDeep_1.default)(attributes) || {};
        this._features = features;
        this._indexById = new Map();
        this.updateIndexes();
    }
    get length() {
        return this._features.length;
    }
    // TODO: Replace all calls to this by getFeatures()
    get features() {
        return this._features;
    }
    get attributes() {
        return this._attributes;
    }
    size() {
        return this._features.length;
    }
    updateIndexes() {
        this.updateIndexById();
    }
    updateIndexesForFeature(feature, index) {
        this._indexById.set(this.getFeatureId(feature), index);
    }
    updateIndexById() {
        this._indexById.clear();
        for (let i = 0, count = this.size(); i < count; i++) {
            const feature = this._features[i];
            const featureId = this.getFeatureId(feature);
            if (!(0, LodashExtensions_1._isBlank)(featureId)) {
                this._indexById.set(featureId, i); // id should be uuid validated by GenericObject
            }
            else {
                console.error('trying to index by id but the feature does not have a valid uuid');
            }
        }
    }
    getFeatures() {
        return this._features;
    }
    getIds() {
        return Array.from(this._indexById.keys());
    }
    getById(featureId) {
        const featureIndex = this._indexById.get(featureId);
        return featureIndex !== undefined && featureIndex >= 0 ? this._features[featureIndex] : undefined;
    }
    getIndex(featureId) {
        if ((0, LodashExtensions_1._isBlank)(featureId)) {
            console.error('feature id is blank');
        }
        if (!(0, uuid_1.validate)(featureId)) {
            console.error('feature id is not a valid uuid');
        }
        return this._indexById.get(featureId);
    }
    getIndexById(featureId) {
        // alias of getIndex
        return this.getIndex(featureId);
    }
    /**
     * @deprecated Use the .attributes accessor instead.
     */
    getAttributes() {
        return this._attributes;
    }
    get socketPrefix() {
        return this.constructor.socketPrefix ? this.constructor.socketPrefix : this.constructor.name;
    }
    get displayName() {
        return this.constructor.displayName ? this.constructor.displayName : this.constructor.name;
    }
    get instanceClass() {
        return this.constructor.instanceClass ? this.constructor.instanceClass : GenericObject_1.GenericObject;
    }
}
exports.default = GenericImmutableCollection;
//# sourceMappingURL=GenericImmutableCollection.js.map